import { global } from '@/global';
import Cookies from 'js-cookie';

export default {
	state: {
		token: Cookies.get(global['ACCESS_TOKEN']) || null,
		user: Cookies.get(global['USER_TOKEN']) || null
	},
	getters: {
		getToken: state => state.token,
		getUser: state => state.user
	},
	mutations: {
		setToken: (state, token) => state.token = token,
		setUser: (state, user) => state.user = user,
		removeToken: (state) => state.token = null,
		removeUser: (state) => state.user = null
	},
	actions: {
		async setTokens({ commit }, response) {
			Cookies.set(global['ACCESS_TOKEN'], response.token, { expires: global['TOKEN_EXPIRES'] })
			Cookies.set(global['USER_TOKEN'], response.email, { expires: global['TOKEN_EXPIRES'] })
			commit('setToken', response.token);
			commit('setUser', response.email);
		},
		async logout({ commit }) {
			return new Promise((resolve) => {
				Cookies.remove(global['ACCESS_TOKEN']);
				Cookies.remove(global['USER_TOKEN']);
				commit('removeToken');
				commit('removeUser');
				resolve(true)
			})
		}
	}
}